export default __webpack_public_path__ + "static/media/backward.10ecc75c.svg";